import { render, staticRenderFns } from "./r-card-package-dropdown-dialog.vue?vue&type=template&id=37b9f394"
import script from "./r-card-package-dropdown-dialog.vue?vue&type=script&lang=js"
export * from "./r-card-package-dropdown-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b9f394')) {
      api.createRecord('37b9f394', component.options)
    } else {
      api.reload('37b9f394', component.options)
    }
    module.hot.accept("./r-card-package-dropdown-dialog.vue?vue&type=template&id=37b9f394", function () {
      api.rerender('37b9f394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card-package/r-card-package-dropdown-dialog.vue"
export default component.exports